<template>
  <div class="zmanim-solar-placemark__container">
    <div
      :class="`zmanim-solar-placemark__dot${now ? '_now' : ''}`"
      :data-title="calloutText"
      :data-time="timeText"
      :data-day="day"
      :style="internalMarkerStyle"
    />
  </div>
</template>

<script>
export default {
  name: 'ZmanimSolarPlacemark',
  props: {
    title: {
      type: String
    },
    time: {
      type: String
    },
    now: {
      type: Boolean,
      default: false
    },
    background: {
      type: String,
      default: 'dark',
      validation (value) {
        return ['dark', 'light'].includes(value)
      },
      clip: {
        type: Boolean,
        default: false
      }
    },
    day: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    calloutText () {
      return this.title
    },
    timeText () {
      if (this.time) {
        return `${this.time}`
      }
      return ''
    },
    timeColor () {
      return this.background === 'dark'
        ? '#fff'
        : '#332924' /* White or dark orange */
    },
    internalMarkerStyle () {
      return {
        '--time-color': `${this.timeColor}`,
        '--zmn-background-clip': `${this.clip ? 'content-box' : 'unset'}`,
        '--zmn-overflow': `${this.clip ? 'hidden' : 'visible'}`
      }
    }
  }
}
</script>

<style scoped>
.zmanim-solar-placemark__container {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: center;
  transition: opacity 300ms linear;
  position: absolute;
  /* margin-top: -50%; */
  flex-grow: 1;
  width: fit-content;
  height: fit-content;
}

.zmanim-solar-placemark__dot::before,
.zmanim-solar-placemark__dot_now::before {
  display: flex;
  flex-grow: 10;
  flex-shrink: 0;
  height: fit-content;
  content: attr(data-title);
  width: fit-content;
  white-space: nowrap;
  font-family: "Avenir-Medium";
  font-size: 0.875rem;
  color: #fff;
  padding: 0.25rem 0.8125rem;
  border-radius: 0.625rem;
  background: rgba(51, 41, 36, 0.85);
  -webkit-backdrop-filter: blur(1rem);
  transform: scale(0.1);
  z-index: 20;
}

.zmanim-solar-placemark__dot::after,
.zmanim-solar-placemark__dot_now::after {
  display: flex;
  flex-grow: 10;
  flex-shrink: 0;
  height: fit-content;
  content: attr(data-time);
  color: var(--time-color);
  width: fit-content;
  white-space: nowrap;
  font-family: "Avenir-Medium";
  font-size: 0.875rem;
  padding: 0.25rem 0.8125rem;
  border-radius: 0.625rem;
  transform: scale(0.1);
  z-index: 20;
}

.zmanim-solar-placemark__dot::before,
.zmanim-solar-placemark__dot::after,
.zmanim-solar-placemark__dot_now::before,
.zmanim-solar-placemark__dot_now::after {
  display: flex;
  flex-grow: 10;
  flex-shrink: 0;
  position: relative;
}

.zmanim-solar-placemark__dot,
.zmanim-solar-placemark__dot_now {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  border-radius: 50%;
}

.zmanim-solar-placemark__dot {
  margin-left: -50%;
  margin-top: -50%;
  transform: scale(0.5);
  background-color: #fff;
  border: 2px solid #ff8511;
  height: 0.9rem;
  width: 0.9rem;
}

.zmanim-solar-placemark__dot_now {
  /* border: 2px solid #ff8511; */
  height: 0.9rem;
  width: 0.9rem;
  padding: 0;
  margin: 0;
  transform: scale(1) translateY(-50%);
}

.zmanim-solar-placemark__dot_now[data-day="true"] {
  background-image: url("/static/logo/logo@3x.png");
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  background-position: center 30%;
  background-clip: var(--zmn-background-clip);
  overflow: var(--zmn-overflow);
  box-shadow: 0 0 5px 2px rgba(255, 132, 17, 0.5),
    0 0 10px 4px rgba(215, 253, 254, 1), 0 0 20px 8px rgba(167, 222, 253, 1),
    0 0 50px 20px rgba(110, 175, 255, 1);
}

.zmanim-solar-placemark__dot_now[data-day="true"] {
  box-shadow: 0 0 10px 4px rgba(255, 255, 255, 1),
    0 0 50px 20px rgba(217, 187, 255, 0.808);
}

.zmanim-solar-placemark__dot_now:not([data-day="true"]) {
  background: none;

  border-radius: 50%;
  height: calc(1rem - 3px);
  width: calc(1rem - 3px);
  border: 1.5px solid white;
  /* box-shadow: 0px 0px 5px 3px rgba(255,255,255,0.45),
  0px 0px 2px 1px rgba(255,255,255,0.75); */
  background-clip: var(--zmn-background-clip);
  overflow: var(--zmn-overflow);
}

.zmanim-solar-placemark__dot::before,
.zmanim-solar-placemark__dot::after,
.zmanim-solar-placemark__dot_now::before,
.zmanim-solar-placemark__dot_now::after {
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.75);
}

.zmanim-solar-placemark__dot,
.zmanim-solar-placemark__dot_now {
  transition: transform 200ms ease, opacity 200ms ease;
}

.zmanim-solar-placemark__dot::before,
.zmanim-solar-placemark__dot::after,
.zmanim-solar-placemark__dot_now::before,
.zmanim-solar-placemark__dot_now::after {
  opacity: 0;
}

/** Hover Effects */
.zmanim-solar-placemark__container:hover,
.zmanim-solar-placemark__dot:hover,
.zmanim-solar-placemark__dot:hover::before,
.zmanim-solar-placemark__dot_now::after,
.zmanim-solar-placemark__dot:hover::after {
  transform: scale(1);
  z-index: 20;
}

.zmanim-solar-placemark__container:hover,
.zmanim-solar-placemark__dot:hover,
.zmanim-solar-placemark__dot:hover::before,
.zmanim-solar-placemark__dot_now::after,
.zmanim-solar-placemark__dot:hover::after {
  opacity: 1;
}

.zmanim-solar-placemark__dot_now::after {
  opacity: 0.35;
}

.zmanim-solar-placemark__dot_now::before,
.zmanim-solar-placemark__dot_now:hover::before {
  opacity: 1;
  margin-bottom: 1rem;
  z-index: 21;
}

.zmanim-solar-placemark__dot_now:hover {
  opacity: 1;
  z-index: 20;
}

.zmanim-solar-placemark__dot_now::before,
.zmanim-solar-placemark__dot:hover::before {
  transform: scale(0.9) translate(0, -60%);
}

.zmanim-solar-placemark__dot_now:hover::after,
.zmanim-solar-placemark__dot:hover::after {
  opacity: 1;
  transform: scale(0.9) translate(0, 40%);
}
.zmanim-solar-placemark__dot:hover {
  background-color: #ff8511;
}
</style>
